interface ScopeBandProps {
  label: string;
}

/**
 * Labels the seam between the portfolio-wide blocks and the per-org blocks.
 *
 * The page carries two scopes and previously distinguished them only by
 * position, so the portfolio-wide credentials table read as though it belonged
 * to whichever org tab was selected. The second band does double duty: it also
 * says what the org tabs below it switch, which nothing else on the page does.
 *
 * The label is written in its natural case and uppercased in CSS, so search,
 * translation and screen readers still see the real words.
 */
export function ScopeBand({ label }: ScopeBandProps) {
  return (
    <div className='mb-4 border-t border-[var(--color-border-secondary)] pt-2'>
      {/* A heading, not body text, so screen-reader users can jump to each scope
          boundary. Level 2 places it directly under the page h1. text-caption
          already applies uppercase + letter-spacing, so no extra classes here. */}
      <span
        role='heading'
        aria-level={2}
        className='block text-caption text-[var(--color-text-tertiary)]'
      >
        {label}
      </span>
    </div>
  );
}
